<template>
    <div class="bg-gray-100 text-black text-base font-medium p-4 my-6 rounded">
        <div v-if="field.instructions_position !== 'below' && field.instructions && field.instructions.length > 0"
             class="text-gray-700 text-sm font-normal"
             v-html="instructions"
        />
        <div class="text-black text-lg font-bold">
            <h2>
                <span class="text-lg tk-museo-sans">
                    {{ field.display }}
                </span>
            </h2>
        </div>
        <div v-if="field.instructions_position === 'below' && field.instructions && field.instructions.length > 0"
             class="text-gray-700 text-sm font-normal"
             v-html="instructions"
        />
        <div class="text-gray-800 text-base font-normal mt-2">
            Fields with <strong>*</strong> are required.
        </div>
    </div>
</template>

<script setup>
import {defineField} from "./BaseField";

const field = defineField();

const instructions = field.instructions && field.instructions.length > 0
    ? field.instructions.replaceAll(/\n/g, '<br>')
    : '';
</script>
